function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { ReactComponent as UploadIcon } from "../../assets/svg/upload.svg";
import { post } from "../../utils";
import { getBaseOrigin } from "../../utils/common";
import { useMount, useMountMethod } from '@micun/form';
import { Button, Modal, Upload, message } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import styles from "./index.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ImportTalentModal = function ImportTalentModal(props) {
  var _useMountMethod = useMountMethod(),
    unmount = _useMountMethod.unmount;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var onSubmit = props.onSubmit,
    onCancel = props.onCancel,
    betaUrl = props.betaUrl,
    prodUrl = props.prodUrl,
    path = props.path;
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    files = _useState4[0],
    setFiles = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var afterOpenChange = useCallback(function (open) {
    if (!open) {
      unmount();
    }
  }, [unmount]);
  var onClose = function onClose() {
    setOpen(false);
    onCancel();
  };
  var isBeta = window.location.host.includes('dev') || window.location.host.includes('beta') || window.location.host.includes('localhost');
  var templateUrl = isBeta ? betaUrl : prodUrl;
  var templateName = useMemo(function () {
    if (!templateUrl) return '模板.xls';
    try {
      var url = new URL(templateUrl);
      var pathname = decodeURIComponent(url.pathname);
      var name = pathname.substring(pathname.lastIndexOf('/') + 1);
      return name || '模板.xls';
    } catch (e) {
      // Fallback if templateUrl is not a full URL
      var decodedUrl = decodeURIComponent(templateUrl);
      var _name = decodedUrl.split('?')[0].split('/').pop();
      return _name || '模板.xls';
    }
  }, [templateUrl]);
  var handleExport = function handleExport() {
    window.open(templateUrl);
  };

  // TODO 增加导入接口处理
  var handleSubmit = function handleSubmit() {
    var _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data;
    console.log(props);
    var formData = new FormData();
    files.forEach(function (file, index) {
      formData.append('file', file);
    });
    Object.keys(data).forEach(function (k) {
      formData.append(k, data[k]);
    });
    setLoading(true);
    post({
      url: path,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 60 * 1000
    }).then(function (res) {
      setLoading(false);
      var code = res.code,
        d = res.data;
      if (code === 0) {
        var _ref = d || {},
          exportPath = _ref.exportPath,
          isSuccess = _ref.isSuccess,
          errorPath = _ref.errorPath,
          successCount = _ref.successCount;
        if (isSuccess) {
          message.success(successCount ? "\u5BFC\u5165\u6210\u529F! \u5171\u5BFC\u5165".concat(successCount, "\u6761\u6570\u636E\u3002") : '导入成功！');
          setOpen(false);
          onSubmit();
        } else if (exportPath) {
          Modal.error({
            title: '导入报错',
            className: styles.files,
            onOk: function onOk() {
              downFile(exportPath);
              setLoading(false);
              setOpen(false);
              onSubmit();
            },
            content: /*#__PURE__*/_jsx("div", {
              children: exportPath ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.fileSub,
                  children: "\u8BF7\u4E0B\u8F7D\u6587\u4EF6\u67E5\u770B\u62A5\u9519\u539F\u56E0"
                }), /*#__PURE__*/_jsx("p", {
                  className: styles.file,
                  onClick: function onClick() {
                    return downFile(exportPath);
                  },
                  children: exportPath
                })]
              }) : null
            })
          });
          return;
        } else {
          Modal.error({
            title: '导入结果',
            className: styles.files,
            onOk: function onOk() {
              return setLoading(false);
            },
            content: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.fileSuccess,
                children: ["\u6210\u529F\u5BFC\u5165", successCount, "\u6761\u6570\u636E"]
              }), errorPath ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.fileSub,
                  children: "\u4E0B\u8F7D\u3010\u5931\u8D25\u6587\u4EF6\u3011\u53EF\u67E5\u770B\u5931\u8D25\u660E\u7EC6"
                }), /*#__PURE__*/_jsx("p", {
                  className: styles.file,
                  onClick: function onClick() {
                    return downError(errorPath);
                  },
                  children: errorPath
                })]
              }) : null]
            })
          });
        }
      }
    }).catch(function () {
      for (var _len = arguments.length, org = new Array(_len), _key = 0; _key < _len; _key++) {
        org[_key] = arguments[_key];
      }
      console.log(org);
      setLoading(false);
    });
  };
  var downError = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(objectName) {
      var isNotProd, host;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isNotProd = window.location.host.includes('dev') || window.location.host.includes('beta') || window.location.host.includes('localhost');
            host = isNotProd ? 'https://static-test.micun.com/' : 'https://static.micun.com/';
            window.open("".concat(host).concat(objectName));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function downError(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var downFile = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(filePath) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            window.open(filePath);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function downFile(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onRemove = function onRemove(file) {
    setFiles(files.filter(function (e) {
      return e.uid !== file.uid;
    }));
  };
  var beforeUpload = function beforeUpload(file, fileList) {
    setFiles([file]);
    return false;
  };
  if (!unmount || typeof unmount !== 'function') {
    throw new Error('useMount must used in [mount] component');
  }
  return /*#__PURE__*/_jsx(Modal, {
    title: "\u5BFC\u5165",
    onCancel: onClose,
    width: 800,
    afterOpenChange: afterOpenChange,
    maskClosable: true,
    closable: true,
    open: open,
    footer: /*#__PURE__*/_jsxs("div", {
      className: "flex justify-center footer",
      style: {
        gap: '16px'
      },
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        children: "\u53D6\u6D88"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleSubmit,
        type: "primary",
        loading: loading,
        disabled: files.length === 0,
        children: "\u5BFC\u5165"
      })]
    }),
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "download-template",
        children: /*#__PURE__*/_jsxs("a", {
          className: "text-sm font-normal text-blue-600",
          onClick: handleExport,
          children: ["\u70B9\u51FB\u4E0B\u8F7D\u6A21\u677F\uFF08", templateName, "\uFF09"]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4",
        children: /*#__PURE__*/_jsx(Upload.Dragger, {
          accept: ".xls,.xlsx",
          action: getBaseOrigin('api') + '/location/import',
          maxCount: 1,
          className: "import-file-container",
          fileList: files,
          showUploadList: true,
          beforeUpload: beforeUpload,
          onRemove: onRemove,
          children: /*#__PURE__*/_jsxs("div", {
            className: "p-5",
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.uploadIconContainer,
              children: /*#__PURE__*/_jsx(UploadIcon, {})
            }), /*#__PURE__*/_jsx("p", {
              className: "ant-upload-text",
              children: "\u70B9\u51FB\u6216\u5C06\u6587\u4EF6\u79FB\u5165\u6B64\u5904\u4E0A\u4F20"
            }), /*#__PURE__*/_jsx("p", {
              className: "mr-auto ml-auto w-96 ant-upload-hint",
              children: "\u8BF7\u6309\u7167\u672C\u9875\u6A21\u677F\u4E0A\u4F20\u6570\u636E\uFF0C\u4E00\u6B21\u53EA\u80FD\u5BFC\u5165\u4E00\u4E2A\u6587\u4EF6\uFF0C\u5BFC\u5165\u6587\u4EF6\u8FC7\u5927\u53EF\u80FD\u5B58\u5728\u8017\u65F6\u8F83\u957F\u7684\u60C5\u51B5\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u3002"
            })]
          })
        })
      })]
    })
  });
};
export var useImportTalentModal = function useImportTalentModal() {
  var mount = useMount();
  return function (_ref4) {
    var path = _ref4.path,
      betaUrl = _ref4.betaUrl,
      prodUrl = _ref4.prodUrl,
      data = _ref4.data;
    return new Promise(function (resolve, reject) {
      mount( /*#__PURE__*/_jsx(ImportTalentModal, {
        onSubmit: resolve,
        onCancel: reject,
        path: path,
        data: data,
        betaUrl: betaUrl,
        prodUrl: prodUrl
      }));
    });
  };
};
export default ImportTalentModal;